(function ($) {

    if (!$.version || $.version.major < 2) {
        throw new Error('This version of OpenSeadragonScalebar requires ' +
            'OpenSeadragon version 2.0.0+');
    }

    $.ScalebarLocation = {
        NONE: 0,
        TOP_LEFT: 1,
        TOP_RIGHT: 2,
        BOTTOM_RIGHT: 3,
        BOTTOM_LEFT: 4
    };


    $.Scalebar = function (options) {
        options = options || {};
        if (!options.viewer) {
            throw new Error("A viewer must be specified.");
        }
        this.viewer = options.viewer;
        this.color = options.color || "black";
        this.fontColor = options.fontColor || "black";
        this.backgroundColor = options.backgroundColor || "none";
        this.fontSize = options.fontSize || "14px";
        this.fontFamily = options.fontFamily || "Inter, \"-apple-system\", BlinkMacSystemFont, \"PingFang SC\", \"Hiragino Sans GB\", \"noto sans\", \"Microsoft YaHei\", \"Helvetica Neue\", Helvetica, Arial, sans-serif";
        this.barThickness = options.barThickness || 2;
        this.mpp = options.mpp || 0.499;
        this.pixelsPerMeter = (1000000 / this.mpp);  // default to 2000 pixels per meter
        this.referenceItemIdx = options.referenceItemIdx || 0;
        this.xOffset = options.xOffset || 5;
        this.yOffset = options.yOffset || 5;
        this.lineSegment = options.lineSegment || 5;
        this.visible = isDefined(options.visible) ? options.visible : true;
        this.divElt = document.createElement("div");

        for (var i = 0; i < this.lineSegment; i++) {
            var lineElt = document.createElement("div");
            lineElt.style.display = "inline-block";
            lineElt.style.height = "100%";
            lineElt.style.boxSizing = "border-box";
            lineElt.style.width = (100 / this.lineSegment).toFixed(6) + "%";
            lineElt.style.borderTop = this.barThickness + "px solid " + this.color;
            lineElt.style.borderRight = this.barThickness + "px solid " + this.color;
            lineElt.style.position = "relative";
            const numElt = document.createElement("div");
            numElt.style.position = "absolute";
            numElt.style.top = "150%";
            numElt.style.right = '0';
            numElt.style.transform = "translateX(50%)";
            numElt.style.backgroundColor = 'rgba(255,255,255,0.6)';
            numElt.style.padding = "0 2px";
            if (i === 0) {
                var zeroElt = document.createElement("div");
                zeroElt.style.position = "absolute";
                zeroElt.style.top = "150%";
                zeroElt.style.left = 0;
                zeroElt.style.transform = "translateX(-50%)";
                zeroElt.style.textShadow = "0 0 4px 4px #ff0000";
                zeroElt.style.backgroundColor = 'rgba(255,255,255,0.6)';
                zeroElt.style.padding = "0 2px";
                lineElt.appendChild(zeroElt);
                lineElt.style.borderLeft = this.barThickness + "px solid " + this.color;
            }
            lineElt.appendChild(numElt);
            lineElt.style.height = "10px";
            lineElt.style.backgroundColor = 'rgba(255,255,255,0.6)';
            this.divElt.appendChild(lineElt);
        }

        this.viewer.container.appendChild(this.divElt);
        this.divElt.style.position = "relative";
        this.divElt.style.margin = "0";
        this.divElt.style.pointerEvents = "none";
        this.setMinWidth(options.minWidth || "800px");

        var self = this;
        this.viewer.addHandler("open", function () {
            self.refresh();
        });
        this.viewer.addHandler("animation", function () {
            self.refresh();
        });
        this.viewer.addHandler("resize", function () {
            self.refresh();
        });
    };

    $.Scalebar.prototype = {
        updateOptions: function (options) {
            if (!options) {
                return;
            }
            if (isDefined(options.minWidth)) {
                this.setMinWidth(options.minWidth);
            }
            if (isDefined(options.color)) {
                this.color = options.color;
            }
            if (isDefined(options.fontColor)) {
                this.fontColor = options.fontColor;
            }
            if (isDefined(options.backgroundColor)) {
                this.backgroundColor = options.backgroundColor;
            }
            if (isDefined(options.fontSize)) {
                this.fontSize = options.fontSize;
            }
            if (isDefined(options.fontFamily)) {
                this.fontFamily = options.fontFamily;
            }
            if (isDefined(options.barThickness)) {
                this.barThickness = options.barThickness;
            }
            if(isDefined(options.mpp)) {
                this.mpp = options.mpp;
                this.pixelsPerMeter = (1000000 / this.mpp);
            }
            if (isDefined(options.referenceItemIdx)) {
                this.referenceItemIdx = options.referenceItemIdx;
            }
            if (isDefined(options.xOffset)) {
                this.xOffset = options.xOffset;
            }
            if (isDefined(options.yOffset)) {
                this.yOffset = options.yOffset;
            }
            if(isDefined(options.visible)) {
                this.visible = options.visible;
            }
        },
        setMinWidth: function (minWidth) {
            this.divElt.style.width = minWidth;
            this.divElt.style.display = "";
            this.minWidth = this.divElt.offsetWidth;
        },
        //ppm 多少像素每米 minSize 多少像素
        sizeAndTextRenderer: function (ppm, minSize) {
            var value = normalize(ppm, minSize);
            var factor = roundSignificand(value / ppm * minSize, 3);
            var size = value * minSize;
            var valueAdnUnit = getWithUnit(factor);
            return {
                size: size,
                unit: valueAdnUnit.unit,
                value: valueAdnUnit.value
            };
        },
        refresh: function (options) {
            this.updateOptions(options);

            if (!this.viewer.isOpen() || !this.visible) {
                this.divElt.style.display = "none";
                return;
            }

            this.divElt.style.display = "";

            var viewport = this.viewer.viewport;
            var tiledImage = this.viewer.world.getItemAt(this.referenceItemIdx);
            var zoom = tiledImageViewportToImageZoom(tiledImage, viewport.getZoom(true));
            var currentPPM = zoom * this.pixelsPerMeter;
            var props = this.sizeAndTextRenderer(currentPPM, this.minWidth);
            this.drawMicroscopyScalebar(props.size, props.unit, props.value);
            var location = this.getScalebarLocation();
            this.divElt.style.left = location.x + "px";
            this.divElt.style.top = location.y + "px";
        },
        drawMicroscopyScalebar: function (size, unit, value) {
            this.divElt.style.fontSize = this.fontSize;
            this.divElt.style.fontFamily = this.fontFamily;
            this.divElt.style.color = this.fontColor;
            var childNodes = this.divElt.childNodes;
            var average = (value / this.lineSegment);
            average = numberFormat(average);
            childNodes.forEach(function (line, index) {
                line.style.borderColor = self.color;
                if (index === 0) {
                    line.firstChild.innerHTML = "0";
                    line.lastChild.innerHTML = average;
                } else {
                    line.firstChild.innerHTML = index === childNodes.length - 1 ? numberFormat(average * (index + 1)) + unit : numberFormat(average * (index + 1));
                }
            });
            this.divElt.style.width = size + "px";
        },
        getScalebarLocation: function () {
            var x, y, container, barHeight, position;
                barHeight = this.divElt.offsetHeight;
                container = this.viewer.container;
                x = 0;
                y = container.offsetHeight - barHeight;
                position = [x + this.xOffset, y - this.yOffset];
            return new $.Point(position[0], position[1]);
        },
        getAsCanvas: function () {
            var canvas = document.createElement("canvas");
            canvas.width = this.divElt.offsetWidth;
            canvas.height = this.divElt.offsetHeight;
            var context = canvas.getContext("2d");
            context.fillStyle = this.backgroundColor;
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.fillStyle = this.color;
            context.fillRect(0, canvas.height - this.barThickness, canvas.width, canvas.height);
            context.font = window.getComputedStyle(this.divElt).font;
            context.textAlign = "center";
            context.textBaseline = "middle";
            context.fillStyle = this.fontColor;
            var hCenter = canvas.width / 2;
            var vCenter = canvas.height / 2;
            context.fillText(this.divElt.textContent, hCenter, vCenter);
            return canvas;
        },
        getImageWithScalebarAsCanvas: function () {
            var imgCanvas = this.viewer.drawer.canvas;
            var newCanvas = document.createElement("canvas");
            newCanvas.width = imgCanvas.width;
            newCanvas.height = imgCanvas.height;
            var newCtx = newCanvas.getContext("2d");
            newCtx.drawImage(imgCanvas, 0, 0);
            var scalebarCanvas = this.getAsCanvas();
            var location = this.getScalebarLocation();
            newCtx.drawImage(scalebarCanvas, location.x, location.y);
            return newCanvas;
        },
        getVisible: function () {
            return this.visible;
        }
    };

    // Missing TiledImage.viewportToImageZoom function in OSD 2.0.0
    function tiledImageViewportToImageZoom(tiledImage, viewportZoom) {
        var ratio = tiledImage._scaleSpring.current.value * tiledImage.viewport._containerInnerSize.x / (tiledImage.source.dimensions.x);
        return ratio * viewportZoom;
    }

    function normalize(value, minSize) {
        var significand = getSignificand(value);
        var minSizeSign = getSignificand(minSize);
        var result = getSignificand(significand / minSizeSign);
        if (result >= 5) {
            result /= 5;
        }
        if (result >= 4) {
            result /= 4;
        }
        if (result >= 2) {
            result /= 2;
        }
        return result;
    }

    function getSignificand(x) {
        return x * Math.pow(10, Math.ceil(-log10(x)));
    }

    function roundSignificand(x, decimalPlaces) {
        var exponent = -Math.ceil(-log10(x));
        var power = decimalPlaces - exponent;
        var significand = x * Math.pow(10, power);
        // To avoid rounding problems, always work with integers
        if (power < 0) {
            return Math.round(significand) * Math.pow(10, -power);
        }
        return Math.round(significand) / Math.pow(10, power);
    }

    function log10(x) {
        return Math.log(x) / Math.log(10);
    }

    //单位换算
    function getWithUnit(value) {
        if (value < 0.000001) {
            return {value: value * 1000000000, unit: "nm"};
        }
        if (value < 0.001) {
            // eslint-disable-next-line no-useless-concat
            return {value: value * 1000000, unit: "\u03BC" + "m"};
        }
        if (value < 1) {
            return {value: value * 1000, unit: "mm"};
        }
        if (value >= 1000) {
            return {value: value / 1000, unit: "km"};
        }
        return {value: value, unit: "m"};
    }

    function isDefined(variable) {
        return typeof (variable) !== "undefined";
    }

    function numberFormat(number) {
        if (Number.isInteger(number)){
            return number.toString();
        } else {
            return number.toFixed(1);
        }
    }
}(OpenSeadragon));
